import { defineStore } from 'pinia';
import { computed, ref } from 'vue';
import type { UserRoleLegacy } from '@getaccept/lib-shared/src/users/types/user-role-legacy';
import type { LaunchDarklyFlags } from '@getaccept/lib-shared/src/launch-darkly/types/launch-darkly-flags';
import { Context } from '../types';
import { EditorHelper } from '../helpers/editor.helper';
import { getIsAdmin } from '../helpers/context-menu/context-menu-root.helper';

export const useEditorMetaDataStore = defineStore('editor-meta-data', () => {
  const context = ref<Context>(null);
  const userId = ref('');
  const userRole = ref<UserRoleLegacy>(null);
  const isAddingRecipient = ref(false);
  const launchDarklyFlags = ref<LaunchDarklyFlags>({});

  const setContext = (newContext: Context) => {
    context.value = newContext;
  };

  const isDsr = computed(() => EditorHelper.isDealroomContext(context.value));

  const isDrSenderSite = computed(() =>
    [Context.DsrEdit, Context.DsrTemplate, Context.DsrResource].includes(context.value)
  );

  const setUserRole = (role: UserRoleLegacy) => {
    userRole.value = role;
  };

  const isAdmin = computed(() => getIsAdmin(userRole.value));

  const setUserId = (id: string) => {
    userId.value = id;
  };

  const setIsAddingRecipient = (value: boolean) => {
    isAddingRecipient.value = value;
  };

  const setLaunchDarklyFlags = (flags: LaunchDarklyFlags) => {
    launchDarklyFlags.value = flags;
  };

  return {
    setContext,
    setUserRole,
    setUserId,
    setIsAddingRecipient,
    setLaunchDarklyFlags,
    context,
    isDsr,
    isDrSenderSite,
    userRole,
    userId,
    isAdmin,
    isAddingRecipient,
    launchDarklyFlags,
  };
});
